"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HylaTradeInReturnCms = void 0;
var HylaTradeInReturnCms = /** @class */ (function () {
    function HylaTradeInReturnCms() {
        this.hylaReturnTitle = 'Returning your trade-in';
        this.hylaReturnDescription = 'You have options on how you’d like to return your trade-in(s).';
        this.hylaDropdownTitle = 'Choose your return option';
        this.hylaReturnOptions = [
            {
                description: 'We’ll include a prepaid return label, bubble wrap, and tape in the same box as your new device shipment.',
                eligibleShipMethods: ['freeship', 'free shipping', 'express shipping', 'standard shipping',
                    'next-day delivery', 'priority', 'standard', 'thirdpartyshippingstandard', 'overnight'],
                priority: '1',
                selectedHylaReturn: 'shippingKit',
                selectedHylaReturnDesc: 'We’ll include shipping supplies with your new device.',
                show: true,
                value: 'Include shipping supplies with my new device',
            },
            {
                description: 'We’ll mail you a return kit which includes a box, prepaid return label and packaging. It should arrive within 10 days after your new device.',
                eligibleShipMethods: ['storepickupshippinggroup', 'expressc2spickupshippinggroup',
                    'dropoffshippinggroup', 'premiumdeliveryshippinggroup'],
                priority: '1',
                selectedHylaReturn: 'hylaSendKit',
                selectedHylaReturnDesc: 'We’ll mail you a return kit separately from new device.',
                show: true,
                value: 'Mail me shipping supplies',
            },
            {
                description: 'We’ll email you a prepaid return label that you can print and put on your own packaging.',
                eligibleShipMethods: ['freeship', 'free shipping', 'express shipping', 'standard shipping',
                    'next-day delivery', 'priority', 'standard', 'thirdpartyshippingstandard', 'overnight', 'storepickupshippinggroup',
                    'expressc2spickupshippinggroup', 'dropoffshippinggroup', 'premiumdeliveryshippinggroup', 'ihxshippinggroup'],
                priority: '2',
                selectedHylaReturn: 'printLabel',
                selectedHylaReturnDesc: 'You’ll print your own return label.',
                show: true,
                value: 'I’ll print my own return label',
            },
            {
                description: 'You’ll drop your trade-in off at a local AT&T store.',
                eligibleShipMethods: ['freeship', 'free shipping', 'express shipping', 'standard shipping',
                    'next-day delivery', 'priority', 'standard', 'thirdpartyshippingstandard', 'overnight', 'storepickupshippinggroup',
                    'expressc2spickupshippinggroup', 'dropoffshippinggroup', 'premiumdeliveryshippinggroup', 'ihxshippinggroup'],
                priority: '3',
                selectedHylaReturn: 'dropOffAtStore',
                selectedHylaReturnDesc: 'You’ll drop it off at an AT&T Store.',
                show: true,
                value: 'I’ll drop it off at an AT&T store',
            },
            {
                description: 'You’ll give your trade-in to your AT&T Right To You expert, and they’ll handle the rest.',
                eligibleShipMethods: ['dropoffshippinggroup', 'premiumdeliveryshippinggroup', 'ihxshippinggroup'],
                priority: '4',
                selectedHylaReturn: 'hylaReturnEnjoy',
                selectedHylaReturnDesc: 'You’ll give it to your AT&T Right To You expert.',
                show: true,
                value: 'I’ll give it to my AT&T Right To You expert',
            },
        ];
    }
    return HylaTradeInReturnCms;
}());
exports.HylaTradeInReturnCms = HylaTradeInReturnCms;
//# sourceMappingURL=HylaTradeInReturn.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/HylaTradeInReturn/HylaTradeInReturn.cms.js
// module id = 1998
// module chunks = 8